import { render, staticRenderFns } from "./AppAbout.vue?vue&type=template&id=e040e442&scoped=true&"
import script from "./AppAbout.vue?vue&type=script&lang=js&"
export * from "./AppAbout.vue?vue&type=script&lang=js&"
import style0 from "./AppAbout.vue?vue&type=style&index=0&id=e040e442&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e040e442",
  null
  
)

export default component.exports